import {
  EditUser,
  RegisterUser,
  RegisterUserResult,
  ClientUser,
  UserQueryFilter,
  EditUserResult,
  ClientBaseUser,
  TokenValidation,
  UserConfig,
  UserConfigChange,
  AuditUserSignInQuery,
  UserAuditRecord,
  ClientUserList,
  ManagementResponse,
  DebugTerminal,
  ParamsDebugTerminal
} from "../types";
import { postServiceCall } from "./base";
import store from "../store";

export async function getUserData(): Promise<ClientBaseUser> {
  return await postServiceCall("user/get", { language: store.state.lang.key });
}

export async function queryUsers(filters: UserQueryFilter): Promise<ClientUser[]> {
  const userList = await postServiceCall<ClientUserList>("user/query", { ...filters, language: store.state.lang.key });
  return userList.users;
}

export async function saveUser(user: EditUser): Promise<EditUserResult> {
  return await postServiceCall<EditUserResult>("user/set", { ...user, language: store.state.lang.key });
}

export async function registerUser(user: RegisterUser): Promise<RegisterUserResult> {
  return await postServiceCall("user/register", { ...user, language: store.state.lang.key });
}

export async function validateToken(paytefToken: string): Promise<TokenValidation> {
  return await postServiceCall("user/validateToken", { token: paytefToken, language: store.state.lang.key });
}

export async function getUserConfig(): Promise<UserConfig> {
  return await postServiceCall("user/configGet", { language: store.state.lang.key });
}

export async function setUserConfig(config: UserConfigChange): Promise<UserConfig> {
  return await postServiceCall("user/configSet", { ...config, language: store.state.lang.key });
}

export async function userAuditQuery(config: AuditUserSignInQuery): Promise<UserAuditRecord[]> {
  return await postServiceCall("user/auditQuery", { ...config, language: store.state.lang.key });
}

export async function queryManagementData(): Promise<ManagementResponse> {
  return await postServiceCall("managementQuery", {});
}

export async function queryDisaDebugTerminals(): Promise<DebugTerminal[]> {
  return await postServiceCall("disaDebugTerminalsList", {});
}

export async function saveDisaDebugTerminals(params: ParamsDebugTerminal): Promise<DebugTerminal[]> {
  return await postServiceCall("disaDebugTerminalsSave", { ...params });
}
